module.exports = __webpack_public_path__ + "static/media/channels.9df8c7e3.svg";